// @flow

import { SchemaTreeGraph } from "../components/Schemas/SchemaTree/SchemaTreeLogic";

/**
 * IMPORTANT: This type is called "SchemaTree" in the database and API. This is an obvious misnomer – it only represents
 * an edge with attributes. However, using a different name here would be even more confusing.
 * The actual schema tree is called {@link SchemaTreeGraph} .
 */
export type SchemaTree = {
  id: number;
  type: SchemaTreeType;
  childId: number;
  parentId: number;
  weight: number;
  scenario: boolean;
  language: boolean;
  interactionData: boolean;
  createdAt: string;
  updatedAt: string;
};

export type SchemaTreeWithPermission = {
  id: number;
  type: SchemaTreeType;
  childId: number;
  parentId: number;
  weight: number;
  scenario: boolean;
  language: boolean;
  interactionData: boolean;
  writable: boolean;
  createdAt: string;
  updatedAt: string;
};

export enum SchemaTreeType {
  GRADING_SERVICE = "gradingservice",
  SCHEMA = "schema",
}
